import React, { Fragment, useEffect, useState } from 'react'
import AgeBars from './AgeBars'
import PiesAge from './PiesAge';


const AgeResults = ({ results }) => {

    const [oneTwelve, setOneTwelve] = useState(0)
    const [oneTen, setOneTen] = useState(0)
    const [oneEight, setOneEight] = useState(0)
    const [oneSix, setOneSix] = useState(0)
    const [oneFour, setOneFour] = useState(0)


    const [fiveTwelve, setFiveTwelve] = useState(0)
    const [fiveTen, setFiveTen] = useState(0)
    const [fiveEight, setFiveEight] = useState(0)
    const [fiveSix, setFiveSix] = useState(0)
    const [fiveFour, setFiveFour] = useState(0)

    useEffect(() => {

        results.forEach((result, i) => {
            if (result.sequenceContext === "Etage R+1") {
                result.results.forEach((res, i) => {
                    if (res.resource.attributes[0].quantity === "8") {
                        setOneTwelve(res.personalData.ageRange)
                    } else if (res.resource.attributes[0].quantity === "10") {
                        setOneTen(res.personalData.ageRange)
                    } else if (res.resource.attributes[0].quantity === "12.5") {
                        setOneEight(res.personalData.ageRange)
                    } else if (res.resource.attributes[0].quantity === "16.5") {
                        setOneSix(res.personalData.ageRange)
                    } else if (res.resource.attributes[0].quantity === "25") {
                        setOneFour(res.personalData.ageRange)
                    }
                })
            } else if (result.sequenceContext === "Etage R+5") {
                result.results.forEach((res, i) => {
                    if (res.resource.attributes[0].quantity === "8.5") {
                        setFiveTwelve(res.personalData.ageRange)
                    } else if (res.resource.attributes[0].quantity === "10") {
                        setFiveTen(res.personalData.ageRange)
                    } else if (res.resource.attributes[0].quantity === "12.5") {
                        setFiveEight(res.personalData.ageRange)
                    } else if (res.resource.attributes[0].quantity === "16.5") {
                        setFiveSix(res.personalData.ageRange)
                    } else if (res.resource.attributes[0].quantity === "25") {
                        setFiveFour(res.personalData.ageRange)
                    }
                })
            }
        }
        )
        // eslint-disable-next-line 

    }, [results])

    const data = [
        {
            name: "1/12",
            "< 20 R+1": oneTwelve.l20 / oneTwelve.total * 100,
            "20-29 R+1": oneTwelve.f20t29 / oneTwelve.total * 100,
            "30-39 R+1": oneTwelve.f30t39 / oneTwelve.total * 100,
            "40-49 R+1": oneTwelve.f40t49 / oneTwelve.total * 100,
            "50-59 R+1": oneTwelve.f50t59 / oneTwelve.total * 100,
            "60-69 R+1": oneTwelve.f60t69 / oneTwelve.total * 100,
            "> 70 R+1": oneTwelve.m70 / oneTwelve.total * 100,
            "< 20 R+5": fiveTwelve.l20 / fiveTwelve.total * 100,
            "20-29 R+5": fiveTwelve.f20t29 / fiveTwelve.total * 100,
            "30-39 R+5": fiveTwelve.f30t39 / fiveTwelve.total * 100,
            "40-49 R+5": fiveTwelve.f40t49 / fiveTwelve.total * 100,
            "50-59 R+5": fiveTwelve.f50t59 / fiveTwelve.total * 100,
            "60-69 R+5": fiveTwelve.f60t69 / fiveTwelve.total * 100,
            "> 70 R+5": fiveTwelve.m70 / fiveTwelve.total * 100,
        },
        {
            name: '1/10',
            "< 20 R+1": oneTen.l20 / oneTen.total * 100,
            "20-29 R+1": oneTen.f20t29 / oneTen.total * 100,
            "30-39 R+1": oneTen.f30t39 / oneTen.total * 100,
            "40-49 R+1": oneTen.f40t49 / oneTen.total * 100,
            "50-59 R+1": oneTen.f50t59 / oneTen.total * 100,
            "60-69 R+1": oneTen.f60t69 / oneTen.total * 100,
            "> 70 R+1": oneTen.m70 / oneTen.total * 100,
            "< 20 R+5": fiveTen.l20 / fiveTen.total * 100,
            "20-29 R+5": fiveTen.f20t29 / fiveTen.total * 100,
            "30-39 R+5": fiveTen.f30t39 / fiveTen.total * 100,
            "40-49 R+5": fiveTen.f40t49 / fiveTen.total * 100,
            "50-59 R+5": fiveTen.f50t59 / fiveTen.total * 100,
            "60-69 R+5": fiveTen.f60t69 / fiveTen.total * 100,
            "> 70 R+5": fiveTen.m70 / fiveTen.total * 100,
        },
        {
            name: '1/8',
            "< 20 R+1": oneEight.l20 / oneEight.total * 100,
            "20-29 R+1": oneEight.f20t29 / oneEight.total * 100,
            "30-39 R+1": oneEight.f30t39 / oneEight.total * 100,
            "40-49 R+1": oneEight.f40t49 / oneEight.total * 100,
            "50-59 R+1": oneEight.f50t59 / oneEight.total * 100,
            "60-69 R+1": oneEight.f60t69 / oneEight.total * 100,
            "> 70 R+1": oneEight.m70 / oneEight.total * 100,
            "< 20 R+5": fiveEight.l20 / fiveEight.total * 100,
            "20-29 R+5": fiveEight.f20t29 / fiveEight.total * 100,
            "30-39 R+5": fiveEight.f30t39 / fiveEight.total * 100,
            "40-49 R+5": fiveEight.f40t49 / fiveEight.total * 100,
            "50-59 R+5": fiveEight.f50t59 / fiveEight.total * 100,
            "60-69 R+5": fiveEight.f60t69 / fiveEight.total * 100,
            "> 70 R+5": fiveEight.m70 / fiveEight.total * 100,
        },
        {
            name: '1/6',
            "< 20 R+1": oneSix.l20 / oneSix.total * 100,
            "20-29 R+1": oneSix.f20t29 / oneSix.total * 100,
            "30-39 R+1": oneSix.f30t39 / oneSix.total * 100,
            "40-49 R+1": oneSix.f40t49 / oneSix.total * 100,
            "50-59 R+1": oneSix.f50t59 / oneSix.total * 100,
            "60-69 R+1": oneSix.f60t69 / oneSix.total * 100,
            "> 70 R+1": oneSix.m70 / oneSix.total * 100,
            "< 20 R+5": fiveSix.l20 / fiveSix.total * 100,
            "20-29 R+5": fiveSix.f20t29 / fiveSix.total * 100,
            "30-39 R+5": fiveSix.f30t39 / fiveSix.total * 100,
            "40-49 R+5": fiveSix.f40t49 / fiveSix.total * 100,
            "50-59 R+5": fiveSix.f50t59 / fiveSix.total * 100,
            "60-69 R+5": fiveSix.f60t69 / fiveSix.total * 100,
            "> 70 R+5": fiveSix.m70 / fiveSix.total * 100,
        },
        {
            name: '1/4',
            "< 20 R+1": oneFour.l20 / oneFour.total * 100,
            "20-29 R+1": oneFour.f20t29 / oneFour.total * 100,
            "30-39 R+1": oneFour.f30t39 / oneFour.total * 100,
            "40-49 R+1": oneFour.f40t49 / oneFour.total * 100,
            "50-59 R+1": oneFour.f50t59 / oneFour.total * 100,
            "60-69 R+1": oneFour.f60t69 / oneFour.total * 100,
            "> 70 R+1": oneFour.m70 / oneFour.total * 100,
            "< 20 R+5": fiveFour.l20 / fiveFour.total * 100,
            "20-29 R+5": fiveFour.f20t29 / fiveFour.total * 100,
            "30-39 R+5": fiveFour.f30t39 / fiveFour.total * 100,
            "40-49 R+5": fiveFour.f40t49 / fiveFour.total * 100,
            "50-59 R+5": fiveFour.f50t59 / fiveFour.total * 100,
            "60-69 R+5": fiveFour.f60t69 / fiveFour.total * 100,
            "> 70 R+5": fiveFour.m70 / fiveFour.total * 100,
        }
    ];

    const pieR1R12 = [
        { name: '> 20', value: oneTwelve.l20 / oneTwelve.total * 100 },
        { name: '20-29', value: oneTwelve.f20t29 / oneTwelve.total * 100 },
        { name: '30-39', value: oneTwelve.f30t39 / oneTwelve.total * 100 },
        { name: '40-49', value: oneTwelve.f40t49 / oneTwelve.total * 100 },
        { name: '50-59', value: oneTwelve.f50t59 / oneTwelve.total * 100 },
        { name: '60-69', value: oneTwelve.f60t69 / oneTwelve.total * 100 },
        { name: '> 70', value: oneTwelve.m70 / oneTwelve.total * 100 },
    ]

    const pieR5R12 = [
        { name: '> 20', value: fiveTwelve.l20 / fiveTwelve.total * 100 },
        { name: '20-29', value: fiveTwelve.f20t29 / fiveTwelve.total * 100 },
        { name: '30-39', value: fiveTwelve.f30t39 / fiveTwelve.total * 100 },
        { name: '40-49', value: fiveTwelve.f40t49 / fiveTwelve.total * 100 },
        { name: '50-59', value: fiveTwelve.f50t59 / fiveTwelve.total * 100 },
        { name: '60-69', value: fiveTwelve.f60t69 / fiveTwelve.total * 100 },
        { name: '> 70', value: fiveTwelve.m70 / fiveTwelve.total * 100 },
    ]

    const pieR1R10 = [
        { name: '> 20', value: oneTen.l20 / oneTen.total * 100 },
        { name: '20-29', value: oneTen.f20t29 / oneTen.total * 100 },
        { name: '30-39', value: oneTen.f30t39 / oneTen.total * 100 },
        { name: '40-49', value: oneTen.f40t49 / oneTen.total * 100 },
        { name: '50-59', value: oneTen.f50t59 / oneTen.total * 100 },
        { name: '60-69', value: oneTen.f60t69 / oneTen.total * 100 },
        { name: '> 70', value: oneTen.m70 / oneTen.total * 100 },
    ]

    const pieR5R10 = [
        { name: '> 20', value: fiveTen.l20 / fiveTen.total * 100 },
        { name: '20-29', value: fiveTen.f20t29 / fiveTen.total * 100 },
        { name: '30-39', value: fiveTen.f30t39 / fiveTen.total * 100 },
        { name: '40-49', value: fiveTen.f40t49 / fiveTen.total * 100 },
        { name: '50-59', value: fiveTen.f50t59 / fiveTen.total * 100 },
        { name: '60-69', value: fiveTen.f60t69 / fiveTen.total * 100 },
        { name: '> 70', value: fiveTen.m70 / fiveTen.total * 100 },
    ]

    const pieR1R8 = [
        { name: '> 20', value: oneEight.l20 / oneEight.total * 100 },
        { name: '20-29', value: oneEight.f20t29 / oneEight.total * 100 },
        { name: '30-39', value: oneEight.f30t39 / oneEight.total * 100 },
        { name: '40-49', value: oneEight.f40t49 / oneEight.total * 100 },
        { name: '50-59', value: oneEight.f50t59 / oneEight.total * 100 },
        { name: '60-69', value: oneEight.f60t69 / oneEight.total * 100 },
        { name: '> 70', value: oneEight.m70 / oneEight.total * 100 },
    ]

    const pieR5R8 = [
        { name: '> 20', value: fiveEight.l20 / fiveEight.total * 100 },
        { name: '20-29', value: fiveEight.f20t29 / fiveEight.total * 100 },
        { name: '30-39', value: fiveEight.f30t39 / fiveEight.total * 100 },
        { name: '40-49', value: fiveEight.f40t49 / fiveEight.total * 100 },
        { name: '50-59', value: fiveEight.f50t59 / fiveEight.total * 100 },
        { name: '60-69', value: fiveEight.f60t69 / fiveEight.total * 100 },
        { name: '> 70', value: fiveEight.m70 / fiveEight.total * 100 },
    ]

    const pieR1R6 = [
        { name: '> 20', value: oneSix.l20 / oneSix.total * 100 },
        { name: '20-29', value: oneSix.f20t29 / oneSix.total * 100 },
        { name: '30-39', value: oneSix.f30t39 / oneSix.total * 100 },
        { name: '40-49', value: oneSix.f40t49 / oneSix.total * 100 },
        { name: '50-59', value: oneSix.f50t59 / oneSix.total * 100 },
        { name: '60-69', value: oneSix.f60t69 / oneSix.total * 100 },
        { name: '> 70', value: oneSix.m70 / oneSix.total * 100 },
    ]

    const pieR5R6 = [
        { name: '> 20', value: fiveSix.l20 / fiveSix.total * 100 },
        { name: '20-29', value: fiveSix.f20t29 / fiveSix.total * 100 },
        { name: '30-39', value: fiveSix.f30t39 / fiveSix.total * 100 },
        { name: '40-49', value: fiveSix.f40t49 / fiveSix.total * 100 },
        { name: '50-59', value: fiveSix.f50t59 / fiveSix.total * 100 },
        { name: '60-69', value: fiveSix.f60t69 / fiveSix.total * 100 },
        { name: '> 70', value: fiveSix.m70 / fiveSix.total * 100 },
    ]

    const pieR1R4 = [
        { name: '> 20', value: oneFour.l20 / oneFour.total * 100 },
        { name: '20-29', value: oneFour.f20t29 / oneFour.total * 100 },
        { name: '30-39', value: oneFour.f30t39 / oneFour.total * 100 },
        { name: '40-49', value: oneFour.f40t49 / oneFour.total * 100 },
        { name: '50-59', value: oneFour.f50t59 / oneFour.total * 100 },
        { name: '60-69', value: oneFour.f60t69 / oneFour.total * 100 },
        { name: '> 70', value: oneFour.m70 / oneFour.total * 100 },
    ]

    const pieR5R4 = [
        { name: '> 20', value: fiveFour.l20 / fiveFour.total * 100 },
        { name: '20-29', value: fiveFour.f20t29 / fiveFour.total * 100 },
        { name: '30-39', value: fiveFour.f30t39 / fiveFour.total * 100 },
        { name: '40-49', value: fiveFour.f40t49 / fiveFour.total * 100 },
        { name: '50-59', value: fiveFour.f50t59 / fiveFour.total * 100 },
        { name: '60-69', value: fiveFour.f60t69 / fiveFour.total * 100 },
        { name: '> 70', value: fiveFour.m70 / fiveFour.total * 100 },
    ]



    return (
        <Fragment>
            <AgeBars
                data={data}
            />
            <br />
            <hr className='margin-top-large margin-bottom-large' />
            <br />
            <div className="displayNoneMobile">
                <PiesAge
                    context="Vote des participants selon leurs tranches d'âge"
                    pieR1R12={pieR1R12}
                    pieR5R12={pieR5R12}
                    pieR1R10={pieR1R10}
                    pieR5R10={pieR5R10}
                    pieR1R8={pieR1R8}
                    pieR5R8={pieR5R8}
                    pieR1R6={pieR1R6}
                    pieR5R6={pieR5R6}
                    pieR1R4={pieR1R4}
                    pieR5R4={pieR5R4}
                />
            </div>

        </Fragment>

    )
}

export default AgeResults
